var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ag-grid-vue',{staticClass:"ag-theme-balham-dark",staticStyle:{"width":"100%","height":"600px"},attrs:{"gridOptions":_vm.gridOptions,"enableColResize":true,"showToolPanel":_vm.showToolPanel,"rowData":_vm.records,"enableSorting":true,"suppressClickEdit":true,"enableFilter":true,"groupHeaders":true,"suppressRowClickSelection":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }